module.exports = __webpack_public_path__ + "static/img/enterprise.49d343c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/aboutUs/enterprise.png
// module id = uQcI
// module chunks = 30